import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class CourseOfStudyDto extends EpimsBaseEntityDto {
	@IsNotEmpty() CourseOfStudyId: string;
	@IsNotEmpty() CourseOfStudyName: string;
	@IsNotEmpty() SubscriberId: string;
	@IsNotEmpty() SubscriptionUserId: string;
}
